module.exports = __webpack_public_path__ + "static/media/info-square.2803ad4b.svg";